import type { GraphApi } from './types'

let activeGraphApi: GraphApi | null = null
let assertWritableContext: (() => void) | null = null
const listeners = new Set<(api: GraphApi | null) => void>()

export function setActiveGraphApi(api: GraphApi | null, assertWritable?: () => void): void {
  if (activeGraphApi === api) {
    assertWritableContext = api ? (assertWritable ?? null) : null
    return
  }
  activeGraphApi = api
  assertWritableContext = api ? (assertWritable ?? null) : null
  for (const listener of listeners) listener(api)
}

export function getActiveGraphApi(): GraphApi | null {
  return activeGraphApi
}

export function isActiveGraphApi(api: GraphApi): boolean {
  return activeGraphApi === api
}

/** Internal guard for mutation paths that predate the public Graph API proxy. */
export function assertActiveGraphWritable(): void {
  if (!activeGraphApi) throw new Error('[graph] strategy editor context is no longer active')
  if (!assertWritableContext) throw new Error('[graph] writable context is unavailable')
  assertWritableContext()
}

export function subscribeActiveGraphApi(listener: (api: GraphApi | null) => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
